// Rohit Khokhar
import React, {useEffect} from 'react';
import {BrowserRouter, Route, Redirect, useHistory} from 'react-router-dom';
import {AnimatedSwitch} from 'react-router-transition';
import {useSelector, useDispatch} from 'react-redux';
import {socketConnect, sendData, socket} from './store/actions';
import {UFrameworkProvider} from "ubs-framework/v2/context";
// import Login from './app-account/authentication/login';
// import MultiFactorAuthenticate from './app-account/authentication/multi-factor-authenticate';
// import SetUpMultiFactor from './app-account/authentication/setup-multi-factor';
import Authorize from './app-account/authentication/authorize';
import OnBoardingLogin from './app-account/on-boarding/login';
import Registration from './app-account/authentication/registration';
// import ResetPassword from './app-account/authentication/resetpassword';
// import ForgotPassword from './app-account/authentication/forgotPassword';
// import ForgotWithRecovery from './app-account/authentication/forget-with-recovery';
// import EmailSent from './app-account/authentication/emailSent';
import RegisterInvite from "./app-account/authentication/registerInivite";
import VerifyEmail from './app-account/authentication/verifyEmail';
import * as Icon from 'ubs-icons';
// import Workspace from "./app-account/authentication/workspace";
import PublicRoute from "./routes/PublicRoute";
import PrivateRoute from "./routes/PrivateRoute";
import VerifyOrganization from "./app-account/authentication/verifyOrganization";
import {Error404} from "./app-account/common/error/Error";
// import ChangePassword from './app-account/authentication/change-first-password'
import UToast from "ubs-framework/v2/UToast";
import UForceLogout from "ubs-framework/v2/UForceLogout";
// import StayTuned from "./app-account/authentication/stay-tuned";
import InviteClient from "./app-account/authentication/invite-client";
import DownloadApp from "./app-account/download-app";
import OnBoardingRegister from './app-account/on-boarding/register'
import OnBoardingForgotPassword from './app-account/on-boarding/forgot-password'
import OnBoardingResetPassword from './app-account/on-boarding/reset-password'
// import TWOFARecoveryCode from './app-account/authentication/2fa-recovery-code';
import VerifyOTP from './app-account/sign-up-v2/verify-otp';
import CompanyDetails from './app-account/sign-up-v2/company-details';
import BuildingAccount from './app-account/sign-up-v2/building-account';
import CompanyOtherInfo from './app-account/sign-up-v2/company-other-info';
import useSocket from './app-account/common/useSocket';
import { showToastSuccess } from 'ubs-framework/v2/common/function';
import { SIGNUP_STEPS, SLUG_TYPE_PRODUCT } from './common/constant';
import InvitationRegister from './app-account/sign-up-v2/invitation-register';

{/** sign up v2 */}
import TrackRegistration from './app-account/sign-up-v2/track-registration';
import Login from './app-account/sign-up-v2/login';
import ForgotPassword from './app-account/sign-up-v2/forgotPassword';
import EmailSent from './app-account/sign-up-v2/emailSent';
import ResetPassword from './app-account/sign-up-v2/resetpassword';
import ForgotWithRecovery from './app-account/sign-up-v2/forget-with-recovery';
import SetUpMultiFactor from './app-account/sign-up-v2/setup-multi-factor';
import MultiFactorAuthenticate from './app-account/sign-up-v2/multi-factor-authenticate';
import TWOFARecoveryCode from './app-account/sign-up-v2/2fa-recovery-code';
import ChangePassword from './app-account/sign-up-v2/change-first-password';
import WorkspaceRedirect from './app-account/workspace-redirect';
// import Registration from './app-account/sign-up-v2/registration';
import StayTuned from './app-account/sign-up-v2/stay-tuned';
import ManageAccount from "./app-account/manage-account";

function App() {
    const _SC = useSelector(e => e.common.socketId)
    const _S3_BASE_URL = useSelector(e => e.common.S3_BASE_URL)
    const _ID = useSelector(e => e?.common?._id)
    const dispatch = useDispatch();
    const history = useHistory();
    const slugParam = window.location.pathname.split('/')[1]

    const slugType = SLUG_TYPE_PRODUCT?.includes(slugParam) ? slugParam : 'track'

    useEffect(() => {
        if (SLUG_TYPE_PRODUCT?.includes(slugParam) && window.location.pathname.split('/')[2] === 'register') {
            localStorage.setItem('slugType', 'track')
        }
    }, [slugType])

    useEffect(() => {
        /**---------------------------------
         * Connect to socket before load routes
         ---------------------------------**/

        socketConnect(dispatch, flag => {
            if (flag) {

            } else {
                /**
                 * Client server socket connection fail sonpm npm
                 * TODO: Refresh popup code Goes here
                 */
            }
        }, history);
    }, [])

    useEffect(() => {
        on();
        return () => off()
    }, [])

    const {on, off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {

            }
        }
    })

    return (
        <UFrameworkProvider value={{ S3_BASE_URL: _S3_BASE_URL, sendData: (event, data) => sendData(dispatch, event, data), useSocket, ID: _ID, SOCKET_ID: _SC, socket }}>
            <>
            {_SC ? <BrowserRouter>
                    <>
                        {/**---------------------------------
                         *  Header goes here
                         *
                         ---------------------------------**/}
                        <AnimatedSwitch
                            atEnter={{opacity: 0}}
                            atLeave={{opacity: 0}}
                            atActive={{opacity: 1}}
                            className="u_switch-wrapper u_h-full"
                        >
                            <PublicRoute component={TrackRegistration} path={`/${slugType}/register`} exact/>
                            <PublicRoute component={VerifyOTP} path={`/${slugType}/verify-otp`}/>
                            <PublicRoute component={CompanyDetails} path={`/${slugType}/company-details`} exact/>
                            <PublicRoute component={CompanyOtherInfo} path={`/:orgId/${slugType}/company-other-info`} exact/>
                            <PublicRoute component={BuildingAccount} path={`/:orgId/${slugType}/building`} exact/>
                            <PublicRoute component={InvitationRegister} path={`/${slugType}/invite/:code`} exact/>

                            <PublicRoute component={OnBoardingLogin} path="/:orgId/login" exact/>
                            <PublicRoute component={OnBoardingRegister} path="/:orgId/register" exact/>
                            <PublicRoute component={OnBoardingForgotPassword} path="/:orgId/forgot-password" exact/>
                            <PublicRoute component={OnBoardingResetPassword} path="/:orgId/reset/:code" exact/>
                            <PublicRoute component={EmailSent} path="/:orgId/email-sent" exact/>

                            {/** Pre-boarding Routes */}
                            <PublicRoute component={OnBoardingLogin} path="/:orgId/preboarding/login" exact/>
                            <PublicRoute component={OnBoardingRegister} path="/:orgId/preboarding/register" exact/>
                            <PublicRoute component={OnBoardingForgotPassword} path="/:orgId/preboarding/forgot-password" exact/>
                            <PublicRoute component={OnBoardingResetPassword} path="/:orgId/preboarding/reset/:code" exact/>
                            <PublicRoute component={EmailSent} path="/:orgId/preboarding/email-sent" exact/>

                            <PublicRoute component={Login} path="/login" exact/>
                            <PublicRoute component={MultiFactorAuthenticate} path="/multi-factor-authenticate" exact/>
                            <PublicRoute component={SetUpMultiFactor} path="/setup-multi-factor" exact/>
                            <PublicRoute component={TWOFARecoveryCode} path="/recovery-code" exact/>
                            <PublicRoute component={ForgotPassword} path="/forgot-password" exact/>
                            <PublicRoute component={ForgotWithRecovery} path="/forget-with-recovery" exact/>
                            <PublicRoute component={ResetPassword} path="/reset-with-recovery" exact/>
                            <PublicRoute component={EmailSent} path="/email-sent" exact/>
                            <PublicRoute component={ResetPassword} path="/reset/:code" exact/>
                            <PublicRoute component={Registration} path="/register" exact/>

                            <PublicRoute component={StayTuned} path="/stay-tuned" exact/>
                            <Route component={VerifyEmail} path="/verify-email" exact/>
                            <Route component={RegisterInvite} path="/invite/:code" exact/>
                            <Route component={InviteClient} path="/invite-client/:token" exact/>

                            <PrivateRoute component={WorkspaceRedirect} path="/workspace" exact/>

                            <PrivateRoute component={ManageAccount} path="/:orgId/manage" />

                            <Route component={Authorize} path="/authorize" exact/>
                            <PrivateRoute component={ChangePassword} path="/change-password" exact/>
                            <PrivateRoute component={VerifyOrganization} path="/verify-organization/:id" exact/>
                            <Route component={DownloadApp} path="/downloads" exact/>

                            <Route exact path="/"><Redirect to="/login"/></Route>
                            <Route path="*" component={Error404}/>
                        </AnimatedSwitch>
                    </>
                </BrowserRouter>
                :
                <div className="u_preloader"><Icon.Preloader /></div>}
            <UToast/>
            <UForceLogout isAccountApp={true} />
        </>
        </UFrameworkProvider>
    );
}

export default App;
